import { render } from "./FormList.vue?vue&type=template&id=2639d710&scoped=true"
import script from "./FormList.vue?vue&type=script&lang=js"
export * from "./FormList.vue?vue&type=script&lang=js"

import "./FormList.vue?vue&type=style&index=0&id=2639d710&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2639d710"]])

export default __exports__